var map = {
	"./Superhero.jpg": 5179,
	"./carlyRun.png": 9223,
	"./customHelmet.png": 9400,
	"./customHip.png": 649,
	"./customMB.png": 3185,
	"./hockeyNight.png": 9314,
	"./johnnyLoaringClassic.png": 2641,
	"./monsterRun.png": 3155,
	"./remember.jpg": 2660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1781;